import type { KeycloakTokenParsed } from 'keycloak-js';
import type { User } from '@/models/user';

const nonEmpty = (value: unknown): value is string =>
  typeof value === 'string' && value.trim().length > 0;

export const normalizeKeycloakUser = (token: KeycloakTokenParsed): User => {
  const user = token as User;

  return {
    ...user,
    groups: Array.isArray(user.groups) ? user.groups : [],
    firstname: nonEmpty(user.firstname) ? user.firstname : user.given_name,
    secondname: nonEmpty(user.secondname) ? user.secondname : user.family_name,
  };
};

export const getUserDisplayName = (user: User | null | undefined): string => {
  const fullName = [
    user?.secondname || user?.family_name,
    user?.firstname || user?.given_name,
    user?.middlename,
  ]
    .filter(nonEmpty)
    .map((part) => part.trim())
    .join(' ');

  return fullName || user?.name?.trim() || user?.preferred_username?.trim() || 'Пользователь';
};

export const getUserLogin = (user: User | null | undefined): string =>
  [user?.email, user?.phone_number, user?.phone, user?.preferred_username].find(nonEmpty)?.trim() ||
  'Логин не указан';
